// @spec IAM-STR-012
// @spec SHL-STR-005
import { createFileRoute } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { OrganizationsList } from '@/components/organizations';
import { CreateOrganizationDialog } from '@/components/organizations/create-organization-dialog';
import { Button } from '@/components/ui/button';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/settings/organizations')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.organizations'),
  }),
  component: OrganizationsPage,
});

function OrganizationsPage() {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const { t } = useTranslation('settings');

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-6xl space-y-8">
        <header className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-3xl font-semibold text-foreground">
              {t('organizationsPage.title')}
            </h1>
            <p className="mt-1 text-muted-foreground">{t('organizationsPage.description')}</p>
          </div>
          <Button
            onClick={() => {
              setCreateDialogOpen(true);
            }}
          >
            <Plus className="mr-2 h-4 w-4" />
            {t('organizationsPage.createOrganization')}
          </Button>
        </header>

        <OrganizationsList />
        <CreateOrganizationDialog open={createDialogOpen} onOpenChange={setCreateDialogOpen} />
      </div>
    </div>
  );
}
